var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsElevator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -839.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Elevator",
    transform: "translate(1970.000000, 839.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,5 L19,5 L19,0 L17,0 L17,5 L15,5 L15,0 L13,0 L13,5 L7,5 C5.8954306,5 5,5.8954306 5,7 L5,32 L25,32 C26.1045704,32 27,31.1045704 27,30 L27,5 Z M13.7652588,19.4760132 L12.0331421,19.4763183 L12.0330811,12.7918091 L10.449524,14.3753662 C9.7731324,15.0517578 8.6763306,15.0517578 8.0000001,14.3753662 L12.899048,9.4763183 L17.7980959,14.3753662 C17.1217043,15.0517578 16.0249025,15.0517578 15.3485109,14.3753662 L13.7651369,12.7919922 L13.7652588,19.4760132 Z M19.1009521,28.8136596 L14.2019042,23.9146118 C14.8782958,23.2382812 15.9750976,23.2382812 16.6514281,23.9146118 L18.2348021,25.4979858 L18.23468,18.8139648 L19.9668577,18.8136596 L19.9668577,25.4981689 L21.5504148,23.9146118 C22.2268064,23.2382812 23.3236082,23.2382812 23.9999998,23.9146118 L19.1009521,28.8136596 Z",
    id: 286
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsElevator);
export default __webpack_public_path__ + "static/media/buildings-elevator.0b2158eb.svg";
export { ForwardRef as ReactComponent };